// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.urban-billboard-sub-card-mobile {
  background: #f7f7f7;
  margin-top: 20px;
}
.card-summary-mobile {
  box-shadow: 2px 2px 13.1px 0px #0000000d;
  background: #ffffff;
  border-radius: 10px;
}
.products-purchase-dates-mobile {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Text-400, #3b3f3d);
  text-decoration: none;
}
.campaigns-upfront-products-mobile-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.default-terms-card-row {
  display: flex;
  align-items: center;
}
.default-terms-radio-mobile .ant-radio-inner {
  width: 20px;
  height: 20px;
}
.default-terms-card-net-value {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.default-terms-radio-btn-card {
  box-shadow: 2px 2px 13.1px 0px #0000000d;
  background: #ffffff;
  width: 100%;
}
.custom-terms-mobile-card {
  box-shadow: 2px 2px 13.1px 0px #0000000d;
  background: #ffffff;
  width: 100%;
  margin-top: 20px;
}
.terms-withdrawn-badge{
    color: #fff;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 4px;
    left: 5rem;
}
.terms-withdrawn-badge .ant-badge-count{
    background: #d2042d;
}
.custom-terms-card-net-value {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  align-items: center;
}
.custom-terms-net-mobile {
  width: 45%;
}
.custom-terms-values-mobile {
  display: flex;
  width: 50%;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
.warning-placeholder {
  width: 16px;
  height: 15px;
}
.default-terms-mobile-label {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.default-terms-card-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-terms-grand-total {
  color: var(--Colors-Text-500, #0a0f0d);
  text-align: right;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.seller-approval-warning-icon-mobile {
  width: 16px !important;
  height: 16px !important;
  flex-shrink: 0;
}

.warning-terms-message-card {
  box-shadow: 2px 2px 13.1px 0px #0000000d;
  background: #ffffff;
  margin: 15px;
}
.warning-terms-message-card.ant-card .ant-card-body {
  padding: 10px !important;
}
.seller-approval-warning-mobile {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.products-held-card {
  box-shadow: 2px 2px 13.1px 0px #0000000d;
  background: #ffffff;
  margin: 15px;
}
.cancellation-card {
  box-shadow: 2px 2px 13.1px 0px #0000000d;
  background: #ffffff;
  margin: 15px;
}
.proceed-to-secure-payment-btn {
  background-color: #d2042d !important;
  width: 100%;
  height: 40px !important;
  cursor: pointer;
}
.proceed-to-secure-payment {
  color: #ffffff;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}
.campaign-payments-main-components {
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
}
.proceed-payment-card {
  position: sticky;
  bottom: 0;
  z-index: 1000;
  background: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 16px;
}
.secure-payment-card {
  bottom: 3rem;
  position: relative;
  flex-shrink: 0;
}
.default-terms-amount-warning-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
}
.default-terms-ampunt-warning-icon {
  width: 10%;
}
.default-terms-amount-warning-text {
  width: 90%;
}
.your-terms-amount-warning-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Text-500, #3b3f3d);
}
.payment-method-mobile-card {
  box-shadow: 2px 2px 13.1px 0px #0000000d;
  background: #ffffff;
  margin: 15px;
}
.pay-by-card-inner-card {
  background: #f5f5f5;
  border: 1px solid #d3d3d3;
  margin-top: 1rem;
  border-radius: 4px;
  padding: 10px;
}
.payment-method-header-text {
  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
}
.pay-by-card-row-mobile {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.pay-by-card-col-mobile {
  display: flex;
  flex-direction: column;
  gap: 1px;
  width: 60%;
  align-items: flex-start;
}
.pay-by-card-icon-col-mobile {
  display: flex;
  flex-direction: row;
  gap: 5px;
  width: 40%;
  align-items: center;
  justify-content: flex-end;
}
.pay-by-card-text {
  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #000000;
}
.secure-check-out-stripe {
  margin-top: 10px;
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 15px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #5b5e5d);
}
.mandatory-check-row-mobile {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  margin-top: 20px;
}
.products-purchase-dates-mobile {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 5px;
}
.radio-inactive {
  transition: opacity 0.3s ease;
}
.disable-pointer {
  pointer-events: none;
}

.radio-active {
  opacity: 1;
  transition: opacity 0.3s ease;
}
.expiry-cvv-mobile-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.expiry-date-col-mobile {
  width: 50%;
}
.cvv-date-col-mobile {
  width: 45%;
}
.card-name-row-mobile {
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-top: 20px;
}
.custom-form-item-height.ant-form-item {
  width: 100% !important;
}
.terms-policy-check-box-mobile .ant-checkbox .ant-checkbox-inner {
  width: 20px !important;
  height: 20px !important;
}
.products-delete-col {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.disabled-opacity {
  opacity: 0.5;
  pointer-events: none;
}
.request-still-wating-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.request-still-wating-text {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  color: var(--Colors-Primary-500, #d2042d);
  cursor: pointer;
}
.request-still-wating-btn {
  width: 50% !important;
}

@media (min-width: 426px) and (max-width: 768px) {
  .products-title-col {
    max-width: 60%;
    display: flex;
    align-items: center;
  }
  .mandatory-check-row-mobile {
    justify-content: flex-start;
  }
  .default-terms-ampunt-warning-icon {
    width: 3%;
  }
  .seller-approval-warning-mobile {
    justify-content: flex-start;
  }
  .complete-campaign-text {
    font-size: 19px;
  }
  .review-secure-row {
    justify-content: center;
  }
  .scrollable-content {
    margin-left: 19px;
  }
}
@media (min-width: 376px) and (max-width: 425px) {
  .proceed-to-secure-payment {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .request-still-wating-text {
    font-size: 15px !important;
  }
}
@media (min-width: 0px) and (max-width: 425px) {
  .default-terms-ampunt-warning-icon {
    width: 8%;
  }

  .time-square-digital-col-text {
    margin-right: 0px !important;
  }
  .time-square-row {
    gap: 10px !important;
  }
  .time-square-row {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: flex-start;
    margin-top: 16px;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .american-card-image .ant-image {
    width: 35% !important;
  }
  .default-terms-mobile-label {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .your-terms-amount-warning-text {
    font-size: 14px !important;
    line-height: 20px !important;
  }
  .product-held-brief-text {
    font-size: 14px !important;
    line-height: 20px !important;
  }
  .cancel-campaign-text {
    font-size: 14px !important;
  }
  .cancellation-refund-link {
    font-size: 14px !important;
  }
  .secure-check-out-stripe {
    font-size: 14px !important;
  }
  .proceeding-check-text {
    font-size: 14px !important;
  }
  .our-payment-link-text {
    font-size: 14px !important;
  }
  .terms-policy-check-box-mobile .ant-checkbox .ant-checkbox-inner {
    width: 16px !important;
    height: 16px !important;
  }
  .only-upfront-charged-text {
    font-family: Roboto;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    color: var(--Colors-Primary-500, #d2042d);
  }
  .important-information {
    font-size: 16px !important;
  }
  .important-information-paragraph-text {
    font-size: 14px !important;
  }
  .our-payment-link-mail {
    font-size: 14px !important;
  }
  .products-title-col {
    max-width: 60%;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }
}

@media (min-width: 0px) and (max-width: 768px) {
  .order-summary-first-step-main-container {
    max-height: 65vh;
    overflow-y: auto;
  }
  .seller-approval-warning-icon.anticon svg {
    width: 20px !important;
    height: 20px !important;
  }
  .seller-approval-warning-icon svg {
    width: 20px !important;
    height: 20px !important;
  }
  .sign-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media (min-width: 0px) and (max-width: 375px) {
  .request-still-wating-btn {
    width: 100% !important;
  }
  .request-still-wating-container {
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    align-items: center;
    align-content: center;
    gap: 10px;
  }
  .products-title-col {
    max-width: 100% !important;
    flex-wrap: wrap;
  }
}
@media (max-width: 768px) {
  .secure-payment-card {
    position: relative;
    bottom: 0px;
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/payments-pages/checkout-mobile-flow/CampaignPayments.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;;EAEnB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,SAAS;EACX;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,SAAS;EACX;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;EACX;EACA;IACE,0BAA0B;IAC1B,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":[".urban-billboard-sub-card-mobile {\n  background: #f7f7f7;\n  margin-top: 20px;\n}\n.card-summary-mobile {\n  box-shadow: 2px 2px 13.1px 0px #0000000d;\n  background: #ffffff;\n  border-radius: 10px;\n}\n.products-purchase-dates-mobile {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 13px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-400, #3b3f3d);\n  text-decoration: none;\n}\n.campaigns-upfront-products-mobile-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.default-terms-card-row {\n  display: flex;\n  align-items: center;\n}\n.default-terms-radio-mobile .ant-radio-inner {\n  width: 20px;\n  height: 20px;\n}\n.default-terms-card-net-value {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n}\n.default-terms-radio-btn-card {\n  box-shadow: 2px 2px 13.1px 0px #0000000d;\n  background: #ffffff;\n  width: 100%;\n}\n.custom-terms-mobile-card {\n  box-shadow: 2px 2px 13.1px 0px #0000000d;\n  background: #ffffff;\n  width: 100%;\n  margin-top: 20px;\n}\n.terms-withdrawn-badge{\n    color: #fff;\n    padding: 0 8px;\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: 4px;\n    left: 5rem;\n}\n.terms-withdrawn-badge .ant-badge-count{\n    background: #d2042d;\n}\n.custom-terms-card-net-value {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  align-items: center;\n}\n.custom-terms-net-mobile {\n  width: 45%;\n}\n.custom-terms-values-mobile {\n  display: flex;\n  width: 50%;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n}\n.warning-placeholder {\n  width: 16px;\n  height: 15px;\n}\n.default-terms-mobile-label {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.default-terms-card-total-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.default-terms-grand-total {\n  color: var(--Colors-Text-500, #0a0f0d);\n  text-align: right;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.seller-approval-warning-icon-mobile {\n  width: 16px !important;\n  height: 16px !important;\n  flex-shrink: 0;\n}\n\n.warning-terms-message-card {\n  box-shadow: 2px 2px 13.1px 0px #0000000d;\n  background: #ffffff;\n  margin: 15px;\n}\n.warning-terms-message-card.ant-card .ant-card-body {\n  padding: 10px !important;\n}\n.seller-approval-warning-mobile {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.products-held-card {\n  box-shadow: 2px 2px 13.1px 0px #0000000d;\n  background: #ffffff;\n  margin: 15px;\n}\n.cancellation-card {\n  box-shadow: 2px 2px 13.1px 0px #0000000d;\n  background: #ffffff;\n  margin: 15px;\n}\n.proceed-to-secure-payment-btn {\n  background-color: #d2042d !important;\n  width: 100%;\n  height: 40px !important;\n  cursor: pointer;\n}\n.proceed-to-secure-payment {\n  color: #ffffff;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-align: center;\n}\n.campaign-payments-main-components {\n  max-height: 80vh;\n  overflow-y: auto;\n  position: relative;\n}\n.proceed-payment-card {\n  position: sticky;\n  bottom: 0;\n  z-index: 1000;\n  background: white;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  padding: 16px;\n}\n.secure-payment-card {\n  bottom: 3rem;\n  position: relative;\n  flex-shrink: 0;\n}\n.default-terms-amount-warning-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 20px;\n}\n.default-terms-ampunt-warning-icon {\n  width: 10%;\n}\n.default-terms-amount-warning-text {\n  width: 90%;\n}\n.your-terms-amount-warning-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-500, #3b3f3d);\n}\n.payment-method-mobile-card {\n  box-shadow: 2px 2px 13.1px 0px #0000000d;\n  background: #ffffff;\n  margin: 15px;\n}\n.pay-by-card-inner-card {\n  background: #f5f5f5;\n  border: 1px solid #d3d3d3;\n  margin-top: 1rem;\n  border-radius: 4px;\n  padding: 10px;\n}\n.payment-method-header-text {\n  font-family: Roboto;\n  font-weight: 600;\n  font-style: SemiBold;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.pay-by-card-row-mobile {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n.pay-by-card-col-mobile {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  width: 60%;\n  align-items: flex-start;\n}\n.pay-by-card-icon-col-mobile {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  width: 40%;\n  align-items: center;\n  justify-content: flex-end;\n}\n.pay-by-card-text {\n  font-family: Roboto;\n  font-weight: 600;\n  font-style: SemiBold;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-align: center;\n  color: #000000;\n}\n.secure-check-out-stripe {\n  margin-top: 10px;\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 15px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #5b5e5d);\n}\n.mandatory-check-row-mobile {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 10px;\n  margin-top: 20px;\n}\n.products-purchase-dates-mobile {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 5px;\n}\n.radio-inactive {\n  transition: opacity 0.3s ease;\n}\n.disable-pointer {\n  pointer-events: none;\n}\n\n.radio-active {\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n.expiry-cvv-mobile-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n.expiry-date-col-mobile {\n  width: 50%;\n}\n.cvv-date-col-mobile {\n  width: 45%;\n}\n.card-name-row-mobile {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  margin-top: 20px;\n}\n.custom-form-item-height.ant-form-item {\n  width: 100% !important;\n}\n.terms-policy-check-box-mobile .ant-checkbox .ant-checkbox-inner {\n  width: 20px !important;\n  height: 20px !important;\n}\n.products-delete-col {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n.disabled-opacity {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.request-still-wating-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n}\n.request-still-wating-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  color: var(--Colors-Primary-500, #d2042d);\n  cursor: pointer;\n}\n.request-still-wating-btn {\n  width: 50% !important;\n}\n\n@media (min-width: 426px) and (max-width: 768px) {\n  .products-title-col {\n    max-width: 60%;\n    display: flex;\n    align-items: center;\n  }\n  .mandatory-check-row-mobile {\n    justify-content: flex-start;\n  }\n  .default-terms-ampunt-warning-icon {\n    width: 3%;\n  }\n  .seller-approval-warning-mobile {\n    justify-content: flex-start;\n  }\n  .complete-campaign-text {\n    font-size: 19px;\n  }\n  .review-secure-row {\n    justify-content: center;\n  }\n  .scrollable-content {\n    margin-left: 19px;\n  }\n}\n@media (min-width: 376px) and (max-width: 425px) {\n  .proceed-to-secure-payment {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .request-still-wating-text {\n    font-size: 15px !important;\n  }\n}\n@media (min-width: 0px) and (max-width: 425px) {\n  .default-terms-ampunt-warning-icon {\n    width: 8%;\n  }\n\n  .time-square-digital-col-text {\n    margin-right: 0px !important;\n  }\n  .time-square-row {\n    gap: 10px !important;\n  }\n  .time-square-row {\n    display: flex;\n    flex-direction: row;\n    align-content: center;\n    justify-content: flex-start;\n    margin-top: 16px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n  .american-card-image .ant-image {\n    width: 35% !important;\n  }\n  .default-terms-mobile-label {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .your-terms-amount-warning-text {\n    font-size: 14px !important;\n    line-height: 20px !important;\n  }\n  .product-held-brief-text {\n    font-size: 14px !important;\n    line-height: 20px !important;\n  }\n  .cancel-campaign-text {\n    font-size: 14px !important;\n  }\n  .cancellation-refund-link {\n    font-size: 14px !important;\n  }\n  .secure-check-out-stripe {\n    font-size: 14px !important;\n  }\n  .proceeding-check-text {\n    font-size: 14px !important;\n  }\n  .our-payment-link-text {\n    font-size: 14px !important;\n  }\n  .terms-policy-check-box-mobile .ant-checkbox .ant-checkbox-inner {\n    width: 16px !important;\n    height: 16px !important;\n  }\n  .only-upfront-charged-text {\n    font-family: Roboto;\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 14px;\n    line-height: 100%;\n    letter-spacing: 0%;\n    color: var(--Colors-Primary-500, #d2042d);\n  }\n  .important-information {\n    font-size: 16px !important;\n  }\n  .important-information-paragraph-text {\n    font-size: 14px !important;\n  }\n  .our-payment-link-mail {\n    font-size: 14px !important;\n  }\n  .products-title-col {\n    max-width: 60%;\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n}\n\n@media (min-width: 0px) and (max-width: 768px) {\n  .order-summary-first-step-main-container {\n    max-height: 65vh;\n    overflow-y: auto;\n  }\n  .seller-approval-warning-icon.anticon svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n  .seller-approval-warning-icon svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n  .sign-content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n@media (min-width: 0px) and (max-width: 375px) {\n  .request-still-wating-btn {\n    width: 100% !important;\n  }\n  .request-still-wating-container {\n    flex-direction: column;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n    align-items: center;\n    align-content: center;\n    gap: 10px;\n  }\n  .products-title-col {\n    max-width: 100% !important;\n    flex-wrap: wrap;\n  }\n}\n@media (max-width: 768px) {\n  .secure-payment-card {\n    position: relative;\n    bottom: 0px;\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
